import React from 'react';
import { TableCell } from '@mui/material';

export default class GridEntityCell extends React.Component {
    render() {
        const items = this.props.field.items;
        const value = items.find((item) => item.id === this.props.value)?.name;
        return <TableCell align="left">{value}</TableCell>;
    }
}
